import { useState } from 'react';
import { COURSE, type MeView } from '@gc/shared';
import { api } from '../lib/api.js';

export interface ProfileProps {
  me: MeView;
  onSettings: (reminderHour: number) => void;
}

const HOURS = [7, 8, 9, 15, 16, 17, 18, 19, 20];

export function Profile({ me, onSettings }: ProfileProps): JSX.Element {
  const [hour, setHour] = useState(me.settings.reminderHour);
  const [error, setError] = useState('');

  async function save(next: number): Promise<void> {
    setHour(next);
    setError('');
    try {
      const res = await api.setReminder(next);
      onSettings(res.reminderHour);
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Не удалось сохранить');
      setHour(me.settings.reminderHour);
    }
  }

  const pct = Math.round((me.progress.completed / me.progress.total) * 100);

  return (
    <div className="screen">
      <div className="card">
        <h2>Привет, {me.user.firstName || 'друг'}</h2>
        <div className="stats">
          <div>
            <span className="big mono">{me.progress.completed}</span>
            <span className="dim">из {me.progress.total} занятий</span>
          </div>
          <div>
            <span className="big mono">{me.progress.streak}</span>
            <span className="dim">дней подряд</span>
          </div>
          <div>
            <span className="big mono">{pct}%</span>
            <span className="dim">курса пройдено</span>
          </div>
        </div>
      </div>

      <div className="card">
        <h3>Напоминание</h3>
        <p className="hint">
          Придёт только в те дни, когда занятия ещё не было. Время — по часовому поясу сервера.
        </p>
        <div className="chips">
          {HOURS.map((h) => (
            <button
              key={h}
              type="button"
              className="chip"
              aria-pressed={hour === h}
              onClick={() => void save(h)}
            >
              {String(h).padStart(2, '0')}:00
            </button>
          ))}
          <button
            type="button"
            className="chip ghost"
            aria-pressed={hour === -1}
            onClick={() => void save(-1)}
          >
            Выключить
          </button>
        </div>
        {error && <p className="error">{error}</p>}
      </div>

      <div className="card">
        <h3>Что понадобится</h3>
        <ul className="bullets">
          {COURSE.meta.gear.map((g, i) => (
            <li key={i}>{g}</li>
          ))}
        </ul>
      </div>

      <div className="card">
        <h3>Правила курса</h3>
        <ul className="bullets">
          {COURSE.meta.rules.map((r, i) => (
            <li key={i}>{r}</li>
          ))}
        </ul>
      </div>
    </div>
  );
}
